import { jsx as _jsx } from "react/jsx-runtime";
import ThemedImage from './ThemedImage';
const BrandIcon = ({ iconName, ...props }) => {
    return _jsx(ThemedImage, { filename: `${iconName}.png`, ...props });
};
export default BrandIcon;
